// generated from 599 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const workflowControlGroupFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("workflow_control_group_filter"),
  comparison_key: z.enum([
    "1", // 389 (64.94%)
    "2", // 210 (35.06%)
  ]),
  display_name: z.string(),
  // undefined: 195 (32.55%), defined 404 (67.45%)
  raw_value: common.objectId.optional(),
  value: z.object({
    // true 171 (28.55%), false 428 (71.45%)
    expired: z.boolean(),
    id: common.objectId,
    value: z.string(),
  }),
  varies_by_app_group: z.literal(true),
});
